import { render, staticRenderFns } from "./Heroes.vue?vue&type=template&id=7af65cac&scoped=true&"
import script from "./Heroes.vue?vue&type=script&lang=js&"
export * from "./Heroes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7af65cac",
  null
  
)

export default component.exports